import { render, staticRenderFns } from "./Slice1.vue?vue&type=template&id=07c5231f&scoped=true"
import script from "./Slice1.vue?vue&type=script&lang=js"
export * from "./Slice1.vue?vue&type=script&lang=js"
import style0 from "./Slice1.vue?vue&type=style&index=0&id=07c5231f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c5231f",
  null
  
)

export default component.exports